export function formatDate(iso: string | null | undefined): string {
  if (!iso || iso === "-") return "—";
  let date: Date;
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    const [year, month, day] = iso.split("-").map(Number);
    date = new Date(year, month - 1, day);
  } else {
    date = new Date(iso);
  }
  return date.toLocaleDateString("ko-KR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
